// Interface text: Kreyòl by default, with English and French for readers
// abroad. What the app listens to and speaks is a separate setting — the voice
// language (src/shared/speech.mjs) — so these are only the labels around it.

const STRINGS = {
  ht: {
    tagline: 'Pale kòb ou, tande chanj lan.',
    'rate.label': 'To jodi a',
    'rate.aria': 'Konbe goud pou yon {currency}',
    'rate.source': 'Source: {name}',
    'rate.manual': 'to pa w',
    'rate.loading': 'n ap chèche…',
    'rate.unavailable': 'antre to a',
    'rate.reset': 'Tounen sou to an dirèk la',
    'cur.usd': 'Dola ameriken',
    'cur.htg': 'Goud',
    'cur.htd': 'Dola ayisyen',
    'cur.eur': 'Ewo',
    'cur.cad': 'Dola kanadyen',
    'cur.dop': 'Peso dominiken',
    'cur.choose': 'Chwazi lajan etranje a',
    'dock.hear': 'Koute',
    'dock.stop': 'Kanpe',
    'dock.speak': 'Pale',
    'dock.done': 'Fini',
    'dock.clear': 'Efase',
    'hint.speak': 'Peze mikwo a epi di yon kantite, pa egzanp «{example}».',
    'hint.ask': 'Oswa poze yon kesyon sou chanj lan.',
    'hint.type': 'Ekri yon kantite pou w wè chanj lan.',
    'state.listening': 'M ap koute…',
    'state.thinking': 'Yon ti moman…',
    heard: 'Mwen tande',
    'box.copy': 'Kopye',
    'box.copied': 'Kopye!',
    'box.share': 'Pataje',
    'box.download': 'Telechaje odyo a',
    'box.assistant': 'Asistan Palefò',
    'dola.usd': 'Dola ameriken pito?',
    'dola.htd': 'Dola ayisyen pito?',
    'error.noSpeech': 'Mwen pa tande anyen. Eseye ankò.',
    'error.noAmount': 'Mwen pa jwenn kantite a. Eseye ankò, pa egzanp «{example}».',
    'error.tooLarge': 'Kantite sa a twò gwo.',
    'error.noRate': 'Antre to chanj lan anvan.',
    'error.micDenied': 'Mikwo a bloke. Bay pèmisyon an nan navigatè a.',
    'error.micMissing': 'Pa gen mikwo sou aparèy sa a.',
    'error.micInsecure': 'Mikwo a mache sèlman sou https.',
    'error.micUnsupported': 'Navigatè sa a pa ka anrejistre vwa.',
    'error.busy': 'Twòp demann. Tann yon ti moman.',
    'error.voice': 'Vwa a pa disponib kounye a. Eseye ankò.',
    'error.voiceOff': 'Vwa Palefò a poko konfigire sou sèvè a.',
    'volume.1': 'Vwa: fò',
    'volume.0.5': 'Vwa: ba',
    'volume.0': 'Vwa: koupe',
    'exchange.button': 'Echanj',
    'exchange.title': 'Echanj',
    'exchange.date': 'Dat',
    'exchange.bank': 'Bank',
    'exchange.buy': 'Achte',
    'exchange.sell': 'Vann',
    'exchange.highest': 'Pi wo',
    'exchange.lowest': 'Pi ba',
    'exchange.loading': 'N ap chèche to bank yo…',
    'exchange.error': 'Nou pa ka jwenn to bank yo kounye a.',
    'exchange.source': 'Sous: BRH, to bank yo afiche',
    'settings.title': 'Reglaj',
    'settings.close': 'Tounen',
    'settings.voiceLang': 'Lang vwa a',
    'settings.voice': 'Vwa',
    'settings.autoSpeak': 'Li repons lan pou kont li',
    'settings.foreign': 'Lajan (ak goud)',
    'settings.showHtd': 'Montre dola ayisyen',
    'settings.bareDola': '«Dola» poukont li vle di',
    'settings.lang': 'Lang aplikasyon an',
    'settings.skin': 'Aparans',
    yes: 'Wi',
    no: 'Non',
    'skin.auto': 'Otomatik',
    'skin.light': 'Klè',
    'skin.dark': 'Fènwa',
  },
  en: {
    tagline: 'Say your money, hear the exchange.',
    'rate.label': "Today's rate",
    'rate.aria': 'Gourdes for one {currency}',
    'rate.source': 'Source: {name}',
    'rate.manual': 'your rate',
    'rate.loading': 'fetching…',
    'rate.unavailable': 'enter the rate',
    'rate.reset': 'Back to the live rate',
    'cur.usd': 'US dollars',
    'cur.htg': 'Gourdes',
    'cur.htd': 'Haitian dollars',
    'cur.eur': 'Euros',
    'cur.cad': 'Canadian dollars',
    'cur.dop': 'Dominican pesos',
    'cur.choose': 'Choose the foreign currency',
    'dock.hear': 'Listen',
    'dock.stop': 'Stop',
    'dock.speak': 'Speak',
    'dock.done': 'Done',
    'dock.clear': 'Clear',
    'hint.speak': 'Tap the mic and say an amount, like «{example}».',
    'hint.ask': 'Or ask a question about the exchange.',
    'hint.type': 'Type an amount to see the exchange.',
    'state.listening': 'Listening…',
    'state.thinking': 'One moment…',
    heard: 'I heard',
    'box.copy': 'Copy',
    'box.copied': 'Copied!',
    'box.share': 'Share',
    'box.download': 'Download the audio',
    'box.assistant': 'Palefò Assistant',
    'dola.usd': 'US dollars instead?',
    'dola.htd': 'Haitian dollars instead?',
    'error.noSpeech': "I didn't hear anything. Try again.",
    'error.noAmount': "I couldn't find an amount. Try again, like «{example}».",
    'error.tooLarge': 'That amount is too large.',
    'error.noRate': 'Enter the exchange rate first.',
    'error.micDenied': 'The microphone is blocked. Allow it in your browser.',
    'error.micMissing': 'No microphone on this device.',
    'error.micInsecure': 'The microphone only works over https.',
    'error.micUnsupported': "This browser can't record audio.",
    'error.busy': 'Too many requests. Wait a moment.',
    'error.voice': 'The voice is unavailable right now. Try again.',
    'error.voiceOff': "The Palefò voice isn't configured on the server yet.",
    'volume.1': 'Voice: loud',
    'volume.0.5': 'Voice: quiet',
    'volume.0': 'Voice: muted',
    'exchange.button': 'Exchange',
    'exchange.title': 'Exchange',
    'exchange.date': 'Date',
    'exchange.bank': 'Bank',
    'exchange.buy': 'Buy',
    'exchange.sell': 'Sell',
    'exchange.highest': 'Highest',
    'exchange.lowest': 'Lowest',
    'exchange.loading': "Fetching the banks' rates…",
    'exchange.error': "The banks' rates can't be reached right now.",
    'exchange.source': 'Source: BRH, rates posted by the banks',
    'settings.title': 'Settings',
    'settings.close': 'Back',
    'settings.voiceLang': 'Voice language',
    'settings.voice': 'Voice',
    'settings.autoSpeak': 'Read the answer aloud',
    'settings.foreign': 'Currency (with gourdes)',
    'settings.showHtd': 'Show Haitian dollars',
    'settings.bareDola': '“Dola” on its own means',
    'settings.lang': 'App language',
    'settings.skin': 'Appearance',
    yes: 'Yes',
    no: 'No',
    'skin.auto': 'Automatic',
    'skin.light': 'Light',
    'skin.dark': 'Dark',
  },
  fr: {
    tagline: 'Dites votre montant, écoutez le change.',
    'rate.label': 'Taux du jour',
    'rate.aria': 'Gourdes pour un {currency}',
    'rate.source': 'Source: {name}',
    'rate.manual': 'votre taux',
    'rate.loading': 'recherche…',
    'rate.unavailable': 'saisissez le taux',
    'rate.reset': 'Revenir au taux en direct',
    'cur.usd': 'Dollars américains',
    'cur.htg': 'Gourdes',
    'cur.htd': 'Dollars haïtiens',
    'cur.eur': 'Euros',
    'cur.cad': 'Dollars canadiens',
    'cur.dop': 'Pesos dominicains',
    'cur.choose': 'Choisir la devise étrangère',
    'dock.hear': 'Écouter',
    'dock.stop': 'Arrêter',
    'dock.speak': 'Parler',
    'dock.done': 'Terminer',
    'dock.clear': 'Effacer',
    'hint.speak': 'Touchez le micro et dites un montant, par exemple «{example}».',
    'hint.ask': 'Ou posez une question sur le change.',
    'hint.type': 'Saisissez un montant pour voir le change.',
    'state.listening': "J'écoute…",
    'state.thinking': 'Un instant…',
    heard: "J'ai entendu",
    'box.copy': 'Copier',
    'box.copied': 'Copié !',
    'box.share': 'Partager',
    'box.download': "Télécharger l'audio",
    'box.assistant': 'Assistant Palefò',
    'dola.usd': 'Plutôt des dollars américains ?',
    'dola.htd': 'Plutôt des dollars haïtiens ?',
    'error.noSpeech': "Je n'ai rien entendu. Réessayez.",
    'error.noAmount': "Je n'ai pas trouvé le montant. Réessayez, par exemple «{example}».",
    'error.tooLarge': 'Ce montant est trop grand.',
    'error.noRate': "Saisissez d'abord le taux de change.",
    'error.micDenied': 'Le micro est bloqué. Autorisez-le dans le navigateur.',
    'error.micMissing': "Pas de micro sur cet appareil.",
    'error.micInsecure': 'Le micro ne fonctionne que sur https.',
    'error.micUnsupported': "Ce navigateur ne peut pas enregistrer la voix.",
    'error.busy': 'Trop de demandes. Patientez un instant.',
    'error.voice': "La voix n'est pas disponible pour le moment. Réessayez.",
    'error.voiceOff': "La voix Palefò n'est pas encore configurée sur le serveur.",
    'volume.1': 'Voix : forte',
    'volume.0.5': 'Voix : basse',
    'volume.0': 'Voix : coupée',
    'exchange.button': 'Change',
    'exchange.title': 'Change',
    'exchange.date': 'Date',
    'exchange.bank': 'Banque',
    'exchange.buy': 'Achat',
    'exchange.sell': 'Vente',
    'exchange.highest': 'Maximum',
    'exchange.lowest': 'Minimum',
    'exchange.loading': 'Recherche des taux des banques…',
    'exchange.error': 'Les taux des banques sont indisponibles pour le moment.',
    'exchange.source': 'Source : BRH, taux affichés par les banques',
    'settings.title': 'Réglages',
    'settings.close': 'Retour',
    'settings.voiceLang': 'Langue de la voix',
    'settings.voice': 'Voix',
    'settings.autoSpeak': 'Lire la réponse à voix haute',
    'settings.foreign': 'Devise (avec la gourde)',
    'settings.showHtd': 'Afficher les dollars haïtiens',
    'settings.bareDola': '« Dola » tout seul signifie',
    'settings.lang': "Langue de l'application",
    'settings.skin': 'Apparence',
    yes: 'Oui',
    no: 'Non',
    'skin.auto': 'Automatique',
    'skin.light': 'Clair',
    'skin.dark': 'Sombre',
  },
};

export const LANGUAGES = [['ht', 'Kreyòl'], ['en', 'English'], ['fr', 'Français']];

// The voice languages — Palefò's eleven — under their own names: someone looking
// for their language recognises "Русский" faster than its Kreyòl name.
export const VOICE_LANGUAGE_NAMES = [
  ['ht', 'Kreyòl'], ['en', 'English'], ['fr', 'Français'], ['es', 'Español'], ['pt', 'Português'], ['it', 'Italiano'],
  ['de', 'Deutsch'], ['ru', 'Русский'], ['zh', '中文'], ['ja', '日本語'], ['ko', '한국어'],
];

/** t(key) or t(key, { example }) — `{name}` in a string is filled from the second argument. */
export const translator = (lang) => (key, values = {}) =>
  (STRINGS[lang]?.[key] ?? STRINGS.ht[key] ?? key).replace(/\{(\w+)\}/g, (_, name) => values[name] ?? '');
